import { FinalOrder } from '@/app/pages/final-order/final-order';
import { createFileRoute } from '@tanstack/react-router';

import { finalOrderSearchSchema } from '@/features/order/config/final-order-search-schema';

export const Route = createFileRoute('/final-order/')({
  component: FinalOrder,
  validateSearch: finalOrderSearchSchema,
});
